import { AfterViewInit, Component, OnChanges, ViewChild, Input, ElementRef } from '@angular/core';

@Component({
    selector: 'app-circle-progressbar',
    templateUrl: './circle-progressbar.component.html',
    styleUrls: ['./circle-progressbar.component.scss']
})
export class CircleProgressbarComponent implements OnChanges, AfterViewInit {
    @ViewChild('circleCanvas', { static: true }) circleCanvas: ElementRef;
    @Input() progressBarColor = '#000000';
    @Input() fontColor = '#000000';
    @Input() fontSize = 16;
    @Input() hasPercentage = false;
    @Input() maxValue: number;
    @Input() progressValue = 0;
    @Input() diameter = 100;
    @Input() circleWidth = 8;
    canvasWidth: number;
    canvasHeight: number;

    constructor() {
        this.canvasWidth = this.diameter + this.circleWidth;
        this.canvasHeight = this.diameter + this.circleWidth;
    }

    public ngOnChanges(): void {
        this.updateProgressBar();
    }

    public ngAfterViewInit(): void {
        this.updateProgressBar();
    }

    private updateProgressBar(): void {
        const canvasContext = this.circleCanvas.nativeElement.getContext('2d');
        const startAngle = 1.5 * Math.PI;
        const centerX = this.canvasWidth / 2;
        const centerY = this.canvasHeight / 2;
        const difference = (this.progressValue / this.maxValue) * Math.PI * 2 * 10;

        canvasContext.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
        canvasContext.lineWidth = this.circleWidth;
        canvasContext.strokeStyle = this.progressBarColor;
        canvasContext.beginPath();
        canvasContext.arc(centerX, centerY, this.diameter / 2, startAngle, difference / 10 + startAngle);
        canvasContext.stroke();
        canvasContext.fillStyle = this.fontColor;
        canvasContext.textBaseline = 'middle';
        canvasContext.textAlign = 'center';
        canvasContext.font = `${this.fontSize}px sans-serif`;
        canvasContext.fillText(`${this.progressValue}${this.hasPercentage ? '%' : ''}`, centerX, centerY);
    }
}
